import React, { useState, useMemo, useRef, useEffect } from 'react'
import { Form, InputGroup } from 'react-bootstrap'
// import { FaSearch } from 'react-icons/fa'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { Modal } from 'rsuite'
import './modal.css'

export default function ModalSearchGlobal({ open, setOpen }) {
  const [search, setSearch] = useState('')
  const [activeIndex, setActiveIndex] = useState(-1)
  const inputRef = useRef(null)
  const adminMenu = JSON.parse(localStorage.getItem('AdminMenu') || '[]')
  const rightMenu = JSON.parse(localStorage.getItem('menu') || '[]')
  const [userNavigated, setUserNavigated] = useState(false)

  const menuData = [...adminMenu, ...rightMenu]
  useEffect(() => {
    if (open) {
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }, [open])

  const filterMenu = (items, search) => {
    if (!search) return items

    const lower = search.toLowerCase()

    return items
      .map((item) => {
        const matchSelf = item.title?.toLowerCase().includes(lower)

        // recursive filtering
        const filteredChildren = item.children?.length
          ? filterMenu(item.children, search)
          : []

        // CASE 1: parent match → keep ALL children
        if (matchSelf) {
          return {
            ...item,
            children: item.children || [],
          }
        }

        // CASE 2: child match → keep filtered children
        if (filteredChildren.length > 0) {
          return {
            ...item,
            children: filteredChildren,
          }
        }

        return null
      })
      .filter(Boolean)
  }
  const filteredMenu = useMemo(
    () => filterMenu(menuData, search),
    [menuData, search]
  )
  const handleClose = () => {
    setOpen(false) // close modal
    setSearch('') // reset search
  }
  const flattenLeafNodes = (items) => {
    let result = []

    items.forEach((item) => {
      const isLeaf = !item.children || item.children.length === 0

      if (isLeaf && item.url) {
        result.push({
          id: item.id,
          url: item.url,
          title: item.title,
        })
      }

      if (item.children?.length) {
        result = result.concat(flattenLeafNodes(item.children))
      }
    })

    return result
  }
  const flatChildren = useMemo(
    () => flattenLeafNodes(filteredMenu),
    [filteredMenu]
  )
  const handleKeyDown = (e) => {
    if (!flatChildren.length) return
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      setUserNavigated(true)
    }

    const lastIndex = flatChildren.length - 1

    if (e.key === 'ArrowDown') {
      e.preventDefault()

      setActiveIndex((i) => (i === -1 || i >= lastIndex ? 0 : i + 1))
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault()

      setActiveIndex((i) => (i <= 0 ? lastIndex : i - 1))
    }
    if (e.key === 'Enter') {
      e.preventDefault()

      const item = flatChildren[activeIndex]

      if (item) {
        handleClose()

        setTimeout(() => {
          window.open(item.url, '_blank', 'noopener,noreferrer')
        }, 100)
      }
    }
    if (e.key === 'Escape') {
      handleClose()
    }
  }

  useEffect(() => {
    if (!search.trim()) {
      setActiveIndex(-1)
      setUserNavigated(false)
      return
    }

    if (!userNavigated && flatChildren.length > 0) {
      setActiveIndex(0)
    }
  }, [search, flatChildren])
  const renderTree = (items) =>
    items.map((item) => {
      const isLeaf = !item.children || item.children.length === 0

      return (
        <div key={item.id} style={{ marginLeft: 10 }}>
          {/* PARENT */}
          {!isLeaf ? (
            <div className="quick-search-category">{item.title}</div>
          ) : (
            <div
              onMouseEnter={() => {
                const index = flatChildren.findIndex((c) => c.id === item.id)
                setActiveIndex(index)
              }}
              style={{
                backgroundColor: 'transparent',
                padding: '8px 8px',
                height: '30px',
                borderRadius: 6,
                cursor: 'pointer',
                border:
                  flatChildren[activeIndex]?.id === item.id
                    ? '2px solid #ffb2b2'
                    : '2px solid transparent',
                transition: 'all 0.2s ease',
              }}
            >
              <Link
                to={item.url}
                onClick={handleClose}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: 'inherit',
                  display: 'block',
                }}
              >
                {item.title}
              </Link>
            </div>
          )}

          {/* CHILDREN */}
          {item.children?.length > 0 && (
            <div style={{ paddingLeft: 15 }}>{renderTree(item.children)}</div>
          )}
        </div>
      )
    })

  return (
    <Modal
      className="quick-search-modal"
      open={open}
      onClose={handleClose}
      size="sm"
      onEntered={() => inputRef.current?.focus()}
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '16px', fontWeight: 600 }}>
          Accès rapide aux fonctionnalités
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* 🔍 SEARCH INPUT */}
        <InputGroup className="mb-3">
          <Form.Control
            ref={inputRef}
            type="text"
            placeholder="Rechercher un menu..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onKeyDown={handleKeyDown}
          />
        </InputGroup>

        {/* 📋 LIST */}
        {search.trim() !== '' && (
          <div className="quick-search-results">
            {filteredMenu?.length > 0 ? (
              renderTree(filteredMenu)
            ) : (
              <div style={{ color: 'gray' }}>Aucun résultat trouvé</div>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  )
}

